import { render } from "./walletOfficialLinks.vue?vue&type=template&id=04e65c86&scoped=true&lang=pug"
import script from "./walletOfficialLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./walletOfficialLinks.vue?vue&type=script&setup=true&lang=js"

import "./walletOfficialLinks.vue?vue&type=style&index=0&id=04e65c86&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e65c86"]])

export default __exports__